import { NodeID } from "@hex-insights/app-modules";
import { useRecordViewOnMount } from "../../Utilities";

export type ViewRecorderProps = {
	id: NodeID;
};

export function ViewRecorder({ id }: ViewRecorderProps) {
	useRecordViewOnMount(id);

	return null;
}
